import { LatLng } from 'leaflet';
const iterateCoords = (coords, callback) => Array.isArray(coords[0])
    ? coords.map((cs, i) => callback(cs, i))
    : [callback(coords, 0)];
const Converter = {
    toLatLngs(coords, getLat, getLng, getVal) {
        const getLatLngCoords = (points, segment) => points.map((point, line) => {
            const params = {
                point,
                segment,
                line,
            };
            return new LatLng(getLat(params), getLng(params), getVal(params));
        });
        return iterateCoords(coords, getLatLngCoords);
    },
};
export default Converter;
